"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.AdsManagerBrochureCard = ({ title, description, children, accentColor = '#3CB684', }) => {
    return (react_1.default.createElement(reactstrap_1.Card, { body: true, className: "my-2 shadow", style: { borderLeft: `15px ${accentColor} solid` } },
        react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true },
            react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
                react_1.default.createElement("h2", null, title),
                react_1.default.createElement("p", { className: "lead mb-0", style: { maxWidth: 600 } }, description)),
            react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, className: "ml-2" },
                react_1.default.createElement("ul", { className: "list-unstyled m-0" }, children)))));
};
exports.AdsManagerBrochureCard.Feature = ({ children, icon, customIcon }) => {
    return (react_1.default.createElement("li", { className: "my-1", style: { width: 400 } },
        react_1.default.createElement(reactstrap_1.Card, { className: "p-1 shadow-sm" },
            react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true },
                react_1.default.createElement(react_if_1.When, { condition: !!(icon || customIcon) },
                    react_1.default.createElement(exports.AdsManagerBrochureCard.FeatureIconWrapper, null, customIcon || (react_1.default.createElement(react_2.OsmosysIcon, { fixedWidth: true, osysIcon: icon, size: "2x" })))),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
                    react_1.default.createElement("p", { className: "m-0" }, children))))));
};
exports.AdsManagerBrochureCard.FeatureIconWrapper = ({ children }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true }, children));
};
//# sourceMappingURL=Card.js.map